import { render, staticRenderFns } from "./ElTableColumnPack.vue?vue&type=template&id=0d30b554"
import script from "./ElTableColumnPack.vue?vue&type=script&lang=js"
export * from "./ElTableColumnPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports